
<template>
  <!--begin::Authentication - Multi-steps-->
  <!--begin::Authentication - Multi-steps-->

  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->

    <!--end::Toolbar-->
    <!--begin::Post-->
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">

        <div class="card">
          <a href="#" class="mt-10 mb-lg-10" style="text-align: center">
          <img alt="Logo" src="@/assets/media/logos/qomerxia-logo.png" class="h-50px" />
        </a>
          <!--begin::Body-->
          <div class="card-body p-10 p-lg-15">
            <!--begin::Content main-->
            <div class="mb-14">
              <!--begin::Heading-->
              <div class="mb-15">
                <!--begin::Title-->
                <h1 class="fs-2x text-dark mb-6">Conditions Générales d'utilisation </h1>
                <!--end::Title-->
                <!--begin::Text-->
                <div class="fs-5 text-gray-600 fw-bold">First, a disclaimer – the entire process of writing a blog post often takes more than a couple of hours, even if you can type eighty words as per minute and your writing skills are sharp.</div>
                <!--end::Text-->
              </div>
              <!--end::Heading-->
              <!--begin::Body-->
              <!--begin::Table-->

              <div class="mb-20 pb-lg-20">
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-8">Conditions</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul class="fs-4 fw-bold mb-6">
                  <li>
                    <span class="text-gray-700">E-commerce site</span>
                  </li>
                  <li class="my-2">
                    <span class="text-gray-700">Company business activity dashboard</span>
                  </li>
                  <li>
                    <span class="text-gray-700">Customer support center</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700 mb-13">If users can free browse and use your website or Admin Panel is used only as interface(eCommerce site) to sell other's products you can use Regular license.
                  <br />If you are going to use the item on one domain and multiple subdomains, you only require one Licence.(ex: www.
                  <span class="text-dark">domain.com</span>/site1 – site2.
                  <span class="text-dark">domain.com</span>– site.3.
                  <span class="text-dark">domain.com</span>).</div>
                <!--end::Text-->
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-7">Multisite License:</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul>
                  <li>
                    <span class="fs-4 fw-bold text-gray-700">It works the same as the Standard License, but you can use it in unlimited count of projects.</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700 mb-13">If users can free browse and use your website is used only as interface(eCommerce site) to sell other's products you can use Regular license. if you are going to use the item on multiple domains, then you will need to purchase a Licence for each domain or buy Multisite License.
                  <br />(ex: www.domain-site-
                  <span class="text-dark">one.com</span>– www.domain-site.
                  <span class="text-dark">two.com</span>– www.site-three-
                  <span class="text-dark">domain.com</span>).</div>
                <!--end::Text-->
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-8">Extended License:</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul class="fs-4 fw-bold mb-6">
                  <li>
                    <span class="text-gray-700">SaaS projects</span>
                  </li>
                  <li class="my-2">
                    <span class="text-gray-700">Photo stock with PRO subscription</span>
                  </li>
                  <li>
                    <span class="text-gray-700">Cloud service with paid plans</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700">E-commerce site Company business activity dashboard Customer support center If users can free browse and use your website is used only as interface(eCommerce site) to sell other's products you can use Regular license. If you are going to use the item on one domain and multiple subdomains, you only require one Licence . (ex: www.domain.com/site1 – site2.domain.com – site.3.domain.com).</div>
                <!--end::Text-->
              </div>

              <div class="mb-20 pb-lg-20">
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-8">Conditions</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul class="fs-4 fw-bold mb-6">
                  <li>
                    <span class="text-gray-700">E-commerce site</span>
                  </li>
                  <li class="my-2">
                    <span class="text-gray-700">Company business activity dashboard</span>
                  </li>
                  <li>
                    <span class="text-gray-700">Customer support center</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700 mb-13">If users can free browse and use your website or Admin Panel is used only as interface(eCommerce site) to sell other's products you can use Regular license.
                  <br />If you are going to use the item on one domain and multiple subdomains, you only require one Licence.(ex: www.
                  <span class="text-dark">domain.com</span>/site1 – site2.
                  <span class="text-dark">domain.com</span>– site.3.
                  <span class="text-dark">domain.com</span>).</div>
                <!--end::Text-->
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-7">Multisite License:</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul>
                  <li>
                    <span class="fs-4 fw-bold text-gray-700">It works the same as the Standard License, but you can use it in unlimited count of projects.</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700 mb-13">If users can free browse and use your website is used only as interface(eCommerce site) to sell other's products you can use Regular license. if you are going to use the item on multiple domains, then you will need to purchase a Licence for each domain or buy Multisite License.
                  <br />(ex: www.domain-site-
                  <span class="text-dark">one.com</span>– www.domain-site.
                  <span class="text-dark">two.com</span>– www.site-three-
                  <span class="text-dark">domain.com</span>).</div>
                <!--end::Text-->
                <!--begin::Title-->
                <h2 class="fw-bolder text-dark mb-8">Extended License:</h2>
                <!--end::Title-->
                <!--begin::List-->
                <ul class="fs-4 fw-bold mb-6">
                  <li>
                    <span class="text-gray-700">SaaS projects</span>
                  </li>
                  <li class="my-2">
                    <span class="text-gray-700">Photo stock with PRO subscription</span>
                  </li>
                  <li>
                    <span class="text-gray-700">Cloud service with paid plans</span>
                  </li>
                </ul>
                <!--end::List-->
                <!--begin::Text-->
                <div class="fs-4 fw-bold text-gray-700">E-commerce site Company business activity dashboard Customer support center If users can free browse and use your website is used only as interface(eCommerce site) to sell other's products you can use Regular license. If you are going to use the item on one domain and multiple subdomains, you only require one Licence . (ex: www.domain.com/site1 – site2.domain.com – site.3.domain.com).</div>
                <!--end::Text-->
              </div>
              <!--end::Block-->
              <!--end::Body-->
            </div>
            <!--end::Content main-->
            <!--begin::Card-->
            <div class="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
              <!--begin::Links-->
              <div class="d-flex flex-center fw-bold fs-6">
                <span class="text-muted text-hover-primary px-2">Powered by</span>
                <!-- <a href="https://netbyus.com" target="_blank" class="text-muted text-hover-primary px-2">NetByUs</a>-->
               </div>
               <!--end::Links-->
            </div>
            <!--end::Card-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::About card-->
        <!--begin::Modal - Support Center - Create Ticket-->
        <!--end::Modal - Support Center - Create Ticket-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::Post-->
  </div>
  <!--end::Authentication - Multi-steps-->

</template>


<style scoped>
@media (max-width: 991px){
  .step-none {
    display: none !important;
  }
}
</style>
